export const ROUTES = {
  LEGAL: {
    PRIVACY: '/privacy',
    TERMS: '/terms',
  },
  AUTH: {
    SIGN_IN: '/auth/sign-in',
    SIGN_UP: '/auth/sign-up',
    FORGOT_PASSWORD: '/auth/forgot-password',
    RESET_PASSWORD: '/auth/reset-password',
    DISAVOW_SIGNUP: '/auth/disavow-signup',
    SSO_CALLBACK: '/auth/sso-callback',
  },
  APP: {
    ONBOARDING: '/app/onboarding',
    DASHBOARD: '/app/dashboard',
    ACCOUNTS: '/app/accounts',
    ACCOUNT_DETAIL: (id: string) => `/app/accounts/${id}`,
    LOANS: '/app/loans',
    LOAN_DETAIL: (id: string) => `/app/loans/${id}`,
    PERSONAL_LOAN_DETAIL: (accountId: string) => `/app/loans/people/${accountId}`,
    TRANSACTIONS: '/app/transactions',
    CALENDAR: '/app/calendar',
    ANALYTICS: '/app/analytics',
    ANALYTICS_TAB: (tab: string) => `/app/analytics/${tab}`,
    GOALS: '/app/goals',
    GOAL_DETAIL: (id: string) => `/app/goals/${id}`,
    BUDGET: '/app/budget',
    CATEGORIES: '/app/categories',
    BUDGETS: '/app/budgets',
    REPORTS: '/app/reports',
    SETTINGS: '/app/settings',
    SETTINGS_PROFILE: '/app/settings#you',
    SETTINGS_SECURITY: '/app/settings#you',
    SETTINGS_HOUSEHOLD: '/app/settings#household',
    SETTINGS_MEMBERS: '/app/settings#members',
    ACCEPT_INVITE: '/app/accept-invite',
    ENABLE_2FA: '/app/settings/security/2fa/enable',
    DISABLE_2FA: '/app/settings/security/2fa/disable',
    SETTINGS_CATEGORIES: '/app/settings/categories',
    SETTINGS_EXPORT: '/app/settings#data',
    SETTINGS_BILLING: '/app/settings#plan',
    RECURRING: '/app/recurring',
    PEOPLE: '/app/people',
    PERSON_DETAIL: (id: string) => `/app/people/${id}`,
  },
} as const
